import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Taille de page',
	PageOrientation: 'Orientation de la page',
	Format: 'Format',
	DPI: 'DPI',
	Generate: 'Générer',
	LanguageName: 'Français',
	LanguageCode: 'fr'
};

export default translation;
